// extracted by mini-css-extract-plugin
export default {"delete-modal":"delete-saved-bills_delete-modal__N2sHk"};